import { render, staticRenderFns } from "./HeaderConfirmation.vue?vue&type=template&id=6c58c038&scoped=true&"
import script from "./HeaderConfirmation.vue?vue&type=script&lang=js&"
export * from "./HeaderConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./HeaderConfirmation.vue?vue&type=style&index=0&id=6c58c038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c58c038",
  null
  
)

export default component.exports